import styled from 'styled-components';
import { toRem, baseVariables } from '../../../styles';

export const StyledCreditCardPurpose = styled.div`
  display: flex;
  flex-direction: column;

  .option-label {
    position: relative;
    margin-bottom: ${toRem(23)};
  }

  input[type='radio'] {
    border: 0;
    clip: rect(0 0 0 0);
    height: ${toRem(1)};
    margin: ${toRem(-1)};
    overflow: hidden;
    padding: 0;
    width: ${toRem(1)};
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  input[type='radio'] + label {
    position: relative;
    display: inline-block;
    cursor: pointer;
    letter-spacing: 0;
    text-transform: none;
    padding-left: ${toRem(30)};
    font-size: ${toRem(16)};
    font-weight: ${baseVariables.font['fontWeightMedium']};
    line-height: ${toRem(24)};
    color: ${baseVariables.color['base10']};

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: ${toRem(2)};
      width: ${toRem(20)};
      height: ${toRem(20)};
      border-radius: 50%;
      border: ${toRem(1)} solid ${baseVariables.color['base10']};
      background-color: ${baseVariables.color['base20']};
    }

    &::after {
      content: '';
      position: absolute;
      display: none;
      top: ${toRem(9)};
      left: ${toRem(7)};
      width: ${toRem(6)};
      height: ${toRem(6)};
      border-radius: 50%;
      background: ${baseVariables.color['base20']};
    }
  }

  input[type='radio']:checked + label {
    &::before {
      background-color: ${baseVariables.color['base10']};
    }

    &::after {
      display: block;
    }
  }

  input[type='radio']:focus + label:before {
    outline: 1px solid var(--t-brand-fg-color) !important;
    outline-offset: 1px;
  }

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
  }
`;
